exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".preview-modal {\n  min-width: 520px;\n  width: auto !important;\n}\n.preview-modal .ant-modal-content {\n  min-width: 520px;\n  display: inline-block;\n}\n.preview-modal img {\n  max-width: 800px;\n  max-height: 600px;\n}\n.preview-modal .modal-title {\n  text-align: left;\n  margin-bottom: 0;\n}\n.ant-upload-select-picture-card i {\n  font-size: 32px;\n  color: #999;\n}\n.ant-upload-select-picture-card .ant-upload-text {\n  margin-top: 8px;\n  color: #666;\n}\n.box-img {\n  width: 100px;\n  height: 60px;\n}\n", ""]);

// exports
